export const EVALUATION_START = "EVALUATION_START";
export const EVALUATION_SUCCESS = "EVALUATION_SUCCESS";
export const EVALUATION_FAILURE = "EVALUATION_FAILURE";
export const GET_EVALUATION_LIST = "GET_EVALUATION_LIST";